import Cookies from "js-cookie";

export const getToken = (key) => Cookies.get(key);

export const setToken = (key, value, options) => Cookies.set(key, value, options || {});

export const removeToken = (key) => Cookies.remove(key);
